export const autostoreDesignSystemPrimitives = {
  primary: {
    /** Figma: color/primary/AS White */
    asWhite: "#FFFFFF",
    /** Figma: color/primary/AS Warm Gray 50 */
    asWarmGray50: "#F8F6F5",
    /** Figma: color/primary/AS Warm Gray 100 */
    asWarmGray100: "#F5F2F0",
    /** Figma: color/primary/AS Warm Gray 200 */
    asWarmGray200: "#E4E0DE",
    /** Figma: color/primary/AS Warm Gray 300 */
    asWarmGray300: "#CCC7C4",
    /** Figma: color/primary/AS Warm Gray 400 */
    asWarmGray400: "#AFABA8",
    /** Figma: color/primary/AS Warm Gray 500 */
    asWarmGray500: "#948E8A",
    /** Figma: color/primary/AS Warm Gray 600 */
    asWarmGray600: "#79726E",
    /** Figma: color/primary/AS Warm Gray 700 */
    asWarmGray700: "#625D5B",
    /** Figma: color/primary/AS Black 800 */
    asBlack800: "#2C2B2A",
    /** Figma: color/primary/AS Black 900 */
    asBlack900: "#000000",
    /** Figma: color/primary/AS Brand Red */
    asBrandRed: "#FD2730",
    /** Figma: color/primary/AS Red 100 */
    asRed100: "#FFE9E9",
    /** Figma: color/primary/AS Red 200 */
    asRed200: "#FFCECE",
    /** Figma: color/primary/AS Red 300 */
    asRed300: "#FFB2B2",
    /** Figma: color/primary/AS Red 400 */
    asRed400: "#FF8686",
    /** Figma: color/primary/AS Red 500 */
    asRed500: "#FF5E5E",
    /** Figma: color/primary/AS Red 600 */
    asRed600: "#E52727",
    /** Figma: color/primary/AS Red 700 */
    asRed700: "#B1140B",
    /** Figma: color/primary/AS Red 800 */
    asRed800: "#570303",
    /** Figma: color/primary/AS Red 900 */
    asRed900: "#310000"
  },
  secondary: {
    /** Figma: color/secondary/AS Blue 100 */
    asBlue100: "#EDF3FC",
    /** Figma: color/secondary/AS Blue 200 */
    asBlue200: "#D1E0FA",
    /** Figma: color/secondary/AS Blue 300 */
    asBlue300: "#B5CEF8",
    /** Figma: color/secondary/AS Blue 400 */
    asBlue400: "#9CBCF4",
    /** Figma: color/secondary/AS Blue 500 */
    asBlue500: "#83ABF0",
    /** Figma: color/secondary/AS Blue 600 */
    asBlue600: "#5D8DE0",
    /** Figma: color/secondary/AS Blue 700 */
    asBlue700: "#3F6EBF",
    /** Figma: color/secondary/AS Blue 800 */
    asBlue800: "#264885",
    /** Figma: color/secondary/AS Blue 900 */
    asBlue900: "#0F1E38"
  },
  tertiary: {
    /** Figma: color/tertiary/AS Purple 100 */
    asPurple100: "#F6EDFC",
    /** Figma: color/tertiary/AS Purple 200 */
    asPurple200: "#E9D5FA",
    /** Figma: color/tertiary/AS Purple 300 */
    asPurple300: "#DDBDF8",
    /** Figma: color/tertiary/AS Purple 400 */
    asPurple400: "#D1A7F4",
    /** Figma: color/tertiary/AS Purple 500 */
    asPurple500: "#C591F0",
    /** Figma: color/tertiary/AS Purple 600 */
    asPurple600: "#AD6EE0",
    /** Figma: color/tertiary/AS Purple 700 */
    asPurple700: "#8D50BF",
    /** Figma: color/tertiary/AS Purple 800 */
    asPurple800: "#603285",
    /** Figma: color/tertiary/AS Purple 900 */
    asPurple900: "#281438",
    /** Figma: color/tertiary/AS Yellow 100 */
    asYellow100: "#FCF4E3",
    /** Figma: color/tertiary/AS Yellow 200 */
    asYellow200: "#FAE8C6",
    /** Figma: color/tertiary/AS Yellow 300 */
    asYellow300: "#F8DCA9",
    /** Figma: color/tertiary/AS Yellow 400 */
    asYellow400: "#F4D190",
    /** Figma: color/tertiary/AS Yellow 500 */
    asYellow500: "#F0C577",
    /** Figma: color/tertiary/AS Yellow 600 */
    asYellow600: "#DFAD50",
    /** Figma: color/tertiary/AS Yellow 700 */
    asYellow700: "#BC8C34",
    /** Figma: color/tertiary/AS Yellow 800 */
    asYellow800: "#805D1D",
    /** Figma: color/tertiary/AS Yellow 900 */
    asYellow900: "#30230A",
    /** Figma: color/tertiary/AS Green 100 */
    asGreen100: "#E6FAE8",
    /** Figma: color/tertiary/AS Green 200 */
    asGreen200: "#D4F6D7",
    /** Figma: color/tertiary/AS Green 300 */
    asGreen300: "#C3F2C6",
    /** Figma: color/tertiary/AS Green 400 */
    asGreen400: "#B0EAB5",
    /** Figma: color/tertiary/AS Green 500 */
    asGreen500: "#9FE1A5",
    /** Figma: color/tertiary/AS Green 600 */
    asGreen600: "#7DC683",
    /** Figma: color/tertiary/AS Green 700 */
    asGreen700: "#5B9B60",
    /** Figma: color/tertiary/AS Green 800 */
    asGreen800: "#38643C",
    /** Figma: color/tertiary/AS Green 900 */
    asGreen900: "#192E1B"
  }
} as const;

export type AutostoreDesignSystemPrimitives =
  typeof autostoreDesignSystemPrimitives;
